/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementParameterLongDto
 */
export interface TrackItMeasurementParameterLongDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterLongDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterLongDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterLongDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterLongDto
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterLongDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterLongDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterLongDto
     */
    $type?: TrackItMeasurementParameterLongDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterLongDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterLongDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterLongDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterLongDtoTypeEnum = typeof TrackItMeasurementParameterLongDtoTypeEnum[keyof typeof TrackItMeasurementParameterLongDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterLongDto interface.
 */
export function instanceOfTrackItMeasurementParameterLongDto(value?: unknown): value is TrackItMeasurementParameterLongDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterLongDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterLongDtoFromJSON(json: any): TrackItMeasurementParameterLongDto {
    return TrackItMeasurementParameterLongDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterLongDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterLongDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'index': json['index'] == null ? undefined : json['index'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterLongDtoToJSON(value?: TrackItMeasurementParameterLongDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'index': value['index'],
        'unit': value['unit'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

